<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />

        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{
                        $t(
                            isUpdate
                                ? "edit-vinculo-forma-pagamento"
                                : "insert-vinculo-forma-pagamento"
                        )
                    }}
                </h1>
                <span
                    v-if="
                        assformapagto.formapagto &&
                        assformapagto.formapagto != null
                    "
                >
                    {{ $t("formapagto") }}:
                    {{ assformapagto.formapagto.descricao }}
                </span>
                <span v-else>
                    {{ $t("formapagto") }}: {{ selected.descricao }}
                </span>
            </div>
            <div class="header-buttons">
                <div class="switchClass">
                    <div>
                        <label>{{ $t("formapagto-online") }}</label>
                        <b-icon 
                            class="ml-1"
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('tooltip-formapagto-online')"
                        />
                    </div>
                    <b-switch
                        :id="generateId(5)"
                        :value="isPagamento"
                        @input="updatePagamento"
                        :title="isPagamento ? $t('sim') : $t('nao')"
                    >
                        <span v-if="isPagamento">{{ $t("sim") }}</span>
                        <span v-else>{{ $t("nao") }}</span>
                    </b-switch>
                </div>
                <button
                    v-show="
                        isPagamento &&
                        assformapagto.chavePagamento
                    "
                    class="delete-btn"
                    type="button"
                    @click="() => isEditChave = !isEditChave"
                >
                    {{ isEditChave ? $t('cancelar') : $t("editar") }}
                </button>
                <button class="save-btn" type="button" @click="save">
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="columns form-columns-fit is-flex-wrap mt-3">
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="reajusteInput"
                    title="valorpedminimo"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    v-model="assformapagto.valorpedminimo"
                    :invalid="isNull(assformapagto.valorpedminimo)"
                    :max="9999999"
                    :required="true"
                    tooltipLabel="informacao-formapagto-valorpedminimo"
                    tooltipSize="is-large"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(2)"
                    ref="valorpedmaximoInput"
                    title="valorpedmaximo"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    v-model="assformapagto.valorpedmaximo"
                    :invalid="isNull(assformapagto.valorpedmaximo)"
                    :max="9999999"
                    :required="true"
                    tooltipLabel="informacao-formapagto-valorpedmaximo"
                    tooltipSize="is-large"
                    tooltipPosition="is-left"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(3)"
                    ref="margemmediapedidoInput"
                    title="margemmediapedido"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    v-model="assformapagto.margemmediapedido"
                    :invalid="isNull(assformapagto.margemmediapedido)"
                    :max="9999999"
                    :required="true"
                    tooltipLabel="informacao-formapagto-margemmediapedido"
                    tooltipSize="is-large"
                    tooltipPosition="is-right"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(4)"
                    ref="desmaximopedidoInput"
                    title="desmaximopedido"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    v-model="assformapagto.desmaximopedido"
                    :invalid="isNull(assformapagto.desmaximopedido)"
                    :max="9999999"
                    :required="true"
                    tooltipLabel="informacao-desmaximopedido"
                    tooltipSize="is-large"
                    tooltipPosition="is-left"
                />
            </div>
            <div
                class="column is-6"
                v-show="
                    (isPagamento && !assformapagto.chavePagamento) ||
                    (isEditChave && isPagamento)
                "
            >
                <v-input
                    :id="generateId(6)"
                    ref="chavePagamentoInputInicial"
                    v-model="chavePagamentoInicial"
                    placeholder="placeholder-preencha"
                    :maxlength="250"
                    title="title-chave-pagamento-codigo-cliente"
                    :msg="'msg-campo-obrigatorio'"
                    :invalid="isNull(chavePagamentoInicial)"
                    :uppercase="false"
                    required
                    tooltipLabel="tooltip-chave-pagamento-codigo-cliente"
                    tooltipSize="is-large"
                    tooltipPosition="is-right"
                />
            </div>
            <div
                class="column is-6"
                v-show="
                    (isPagamento && !assformapagto.chavePagamento) ||
                    (isEditChave && isPagamento)
                "
            >
                <v-input
                    :id="generateId(7)"
                    ref="chavePagamentoInputFinal"
                    v-model="chavePagamentoFinal"
                    placeholder="placeholder-preencha"
                    :maxlength="250"
                    title="title-chave-pagamento-secret-cliente"
                    :msg="'msg-campo-obrigatorio'"
                    :invalid="isNull(chavePagamentoFinal)"
                    :uppercase="false"
                    required
                    tooltipLabel="tooltip-chave-pagamento-secret-cliente"
                    tooltipSize="is-large"
                    tooltipPosition="is-right"
                />
            </div>
            <div
                class="column is-12 is-default-text-color"
                v-show="
                    isPagamento && assformapagto.chavePagamento && !isEditChave
                "
            >
                <span>{{ $t("msg-existing-key") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import AssFormaPagamentoEmpresa from "@/services/vendas/empresa/abas/AssFormaPagamentoEmpresaService";
import Message from "@/models/Message";

export default {
    props: {
        selected: {
            type: Object,
            default: () => {},
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AssFormaPagamentoEmpresa(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            assformapagto: {
                idformapagtoempresa: null,
                idformapagto: null,
                idempresa: null,
                valorpedminimo: 0,
                margemmediapedido: 0,
                valorpedmaximo: 0,
                desmaximopedido: 0,
                formapagto: null,
                pagamentoOnline: "N",
                chavePagamento: "",
            },
            isPagamento: false,
            chavePagamentoInicial: "",
            chavePagamentoFinal: "",
            isEditChave: false,

            isVenda: this.$route.meta.contexto == "vendas",
        };
    },
    created() {
        this.assformapagto.idempresa = this.selected.idempresa;
        this.assformapagto.idformapagto = this.selected.idformapagto;
        if (this.selected.idformapagtoempresa != null) {
            this.carregarDados(this.selected.idformapagtoempresa);
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.assformapagto = value.content;
                    this.isPagamento =
                        this.assformapagto.pagamentoOnline === "S";
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },

        generateId(numberId) {
            return this.$route.name + "-assformapagto-" + numberId;
        },
        save() {
            this.isLoading = true;

            if (!this.validateChaveApi()) {
                return;
            }

            // indica se a forma de pagamento utilizará meio de pagamento online!
            this.assformapagto.pagamentoOnline = this.isPagamento ? "S" : "N";

            this.saveAssFPE()
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(
                            new Message("error", `${value.message}`, true)
                        );
                    } else {
                        this.$root.showMessage(
                            "success",
                            this.assformapagto.idformapagtoempresa != null
                                ? "msg-sucesso-ao-editar-associcao"
                                : "msg-sucesso-ao-adicionar-associacao"
                        );
                        setTimeout(() => {
                            this.$emit("fecharModal", true);
                        }, 200);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        saveAssFPE() {
            if (this.isVenda) return this.service.saveVendas(this.assformapagto);
            else return this.service.saveAgro(this.assformapagto);
        },
        updatePagamento(isPagamento) {
            this.isPagamento = isPagamento;
        },
        validateChaveApi() {
            let validate = true;
            let invalidChaveInicial = this.isNull(this.chavePagamentoInicial);
            let invalidChaveFinal = this.isNull(this.chavePagamentoFinal);
            let isCreate = !this.assformapagto.chavePagamento;
            if (
                (this.isEditChave || (isCreate && this.isPagamento)) &&
                (invalidChaveInicial || invalidChaveFinal)
            ) {
                this.$root.showMessage("alert", "msg-campos-obrigatorios");
                this.isLoading = false;

                if (invalidChaveInicial) {
                    this.$refs.chavePagamentoInputInicial.focusedOut = true;
                }

                if (invalidChaveFinal) {
                    this.$refs.chavePagamentoInputFinal.focusedOut = true;
                }
                validate = false;
            } else {
                if (!this.isPagamento) {
                    this.assformapagto.chavePagamento = null;
                } else {
                    if (this.isEditChave || isCreate) {
                        // concatena a chave inicial com a final utilzando os dois pontos, modelo da cielo
                        let chavePagamento = `${this.chavePagamentoInicial}:${this.chavePagamentoFinal}`;
                        // codifica para base 64.
                        this.assformapagto.chavePagamento = btoa(chavePagamento);
                    }
                }
            }
            return validate;
        },
    },
};
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;
}
</style>
